import { createSlice } from "@reduxjs/toolkit";
import { FirestoreService } from "../../../shared/api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../shared/api/firebase/references";
import { NycbMedicalPaPatient } from "../../data-model/nycbMedicalPaPatient";
import { logDataToConsole } from "../../utils/customLogger";

interface NycbsMedicalPaPatientsState {
  patients: NycbMedicalPaPatient[] | null;
  loading: boolean;
  error: string | null;
}

const initialState: NycbsMedicalPaPatientsState = {
  patients: null,
  loading: false,
  error: null,
};

const nycbsMedicalPaPatientsSlice = createSlice({
  name: "nycbsMedicalPaPatients",
  initialState,
  reducers: {
    setPatients: (state, action) => {
      state.patients = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
      state.patients = null;
      state.error = null;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.patients = null;
    },
  },
});

export const fetchNycbsMedicalPaOrdersFromFirebase =
  (id: string) => async (dispatch, getState) => {
    const { nycbsMedicalPaPatients } = getState();
    if (nycbsMedicalPaPatients.loading) return;

    dispatch(nycbsMedicalPaPatientsSlice.actions.setLoading(true));

    const unsubscribe =
      FirestoreService.listenToQueryCollection<NycbMedicalPaPatient>(
        FirestoreCollectionReference.nycbsMedicalPaPatients(id),
        (data) => {
          logDataToConsole("nycbsMedicalPaPatient", data);
          const patients = data.map((patient) => ({
            id: patient.id,
            status: patient.status,
          }));

          dispatch(nycbsMedicalPaPatientsSlice.actions.setPatients(patients));
        },
        (error) => {
          dispatch(nycbsMedicalPaPatientsSlice.actions.setError(error.message));
        },
      );

    return unsubscribe;
  };

export default nycbsMedicalPaPatientsSlice.reducer;
